import React from 'react';
import { connect } from '@gasbuddy/react';
import { Header, FlexGrid } from '@gasbuddy/react-components';

import MainLayout from '../../components/main-layout';
import CTAContainer from '../../components/cta-container';
import BuildReportButton from '../../components/build-report-button';
import SharePageButton from '../../components/share-page-button';
import BpDateRangePicker from '../../components/bp-date-range-picker';
import PageHeader from '../../components/page-header';
import StationListSelector from '../../components/station-list-selector-v2';
import ReviewsList from '../../components/reviews-list';
import Notification from '../../components/notification';

import RoleAccessGroup from '../../../lib/constants/role-access-groups';

import styles from './styles.css';

const { api } = require('../../../lib/bputils').default;


/* eslint-disable react/prefer-stateless-function */
function StationReviews() {
  const [stationListId, setStationListId] = React.useState(null);
  const [dateRange, setDateRange] = React.useState(null);

  const handleGenerateReport = async (emails, comments, startDate, endDate) => {
    await api.post(
      {
        path: '/reports/station-reviews',
        data: {
          recipients: emails,
          message: comments,
          station_list_id: stationListId,
          start_date: startDate,
          end_date: endDate,
        },
        requestId: 'requestReviewsReport',
        success: () => Notification.success('Successfully requested a report of your reviews'),
        error: () => Notification.error('We were unable to complete your request. Please try again or contact support if the issue persists.'),
      },
    );
  };

  const handleOnDateRangeChange = ({ startDate, endDate }) => {
    setDateRange({ start: startDate.format('YYYY-MM-DD'), end: endDate.format('YYYY-MM-DD') });
  };


  return (
    <MainLayout>
      <FlexGrid container>
        <FlexGrid.Column mobile={12} tablet={5}>
          <PageHeader title="Station Reviews" />
          <div>
            <StationListSelector
              onChange={setStationListId}
              storeSelectedList
              createStationListOption
              searchable
            />
          </div>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={7}>
          <CTAContainer alignment="right">
            <FlexGrid.Column>
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
                <BuildReportButton
                  onGenerateReport={handleGenerateReport}
                  gTagTitle="Station Reviews - Build Report"
                  hideComparisonSelector
                  roleClasses={RoleAccessGroup.Editor}
                />
                <SharePageButton gTagTitle="Station Reviews - Share Report" />
              </div>
            </FlexGrid.Column>
            <FlexGrid.Column>
              <div className={styles.datePickerWrapper}>
                <Header as="h6">
                Date Range
                </Header>
                <BpDateRangePicker
                  className={styles.filterComponent}
                  gTagTitle="Competition Tab Date Range Picker"
                  onChange={handleOnDateRangeChange}
                />
              </div>
            </FlexGrid.Column>
          </CTAContainer>
        </FlexGrid.Column>
      </FlexGrid>
      {
        stationListId && (
          <FlexGrid container>
            <FlexGrid.Column>
              <ReviewsList stationListId={stationListId} startDate={dateRange.start} endDate={dateRange.end} />
            </FlexGrid.Column>
          </FlexGrid>
        )
      }
    </MainLayout>
  );
}

export default connect()(StationReviews);
